import React from 'react';

import Accessory from './Accessory';
import Articles from './Articles';
import Forum from './Forum';
// import Hap from './Hap';
import Hollaex from './Hollaex';
import QuickLaunch from './QuickLaunch';
import Token from './Token';
import Update from './Update';
// import Vault from './Vault';

const RandomPannel = ({ num }) => {
	num = 4
	switch (num) {
		case 1:
			return <Accessory />;
		case 2:
			return <Articles />;
		case 3:
			return <Forum />;
		case 5:
			return <Forum />;
		// case 6:
		// 	return <Hap />;
		case 7:
			return <Hollaex />;
		case 8:
			return <QuickLaunch />;
		case 9:
			return <Token />;
		case 10:
			return <Update />;
		default:
			return <Hollaex />;
	}
};

export default RandomPannel;
